<template>
  <div class="notification-list">
    <div class="header">新通知</div>
    <notification-item
      v-for="notification in newNotifications"
      :key="`unread-notification-${notification.ID}`"
      :notification="notification"
    />
    <div
      v-if="newNotifications.length==0"
      class="empty-hint"
    >目前沒有通知</div>
    <div class="header">先前的通知</div>
    <notification-item
      v-for="notification in readedNotifications"
      :key="`readed-notification-${notification.ID}`"
      :notification="notification"
    />
    <v-progress-circular
      v-show="isLoadingReadedNotifications"
      indeterminate
      color="white"
    ></v-progress-circular>
    <v-btn
      v-show="hasMoreReadedNotifications && !isLoadingReadedNotifications"
      class="btn-more"
      style="background-color: black;"
      a="b"
      text
      @click.stop="loadMoreReadedNotifications"
    >載入更多...</v-btn>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import NotificationItem from "./notification-item.vue";
export default {
  components: { NotificationItem },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.name === "xs";
    },
    isLoadingReadedNotifications() {
      return this.$store.state.notification.readed.isFetching;
    },
    hasMoreReadedNotifications() {
      return (
        this.$store.state.notification.readed.totalCount >
        this.readedNotifications.length
      );
    },
    ...mapGetters(["newNotifications", "readedNotifications"])
  },
  methods: {
    loadMoreReadedNotifications() {
      this.$store.state.notification.readed.isFetching = true;
      this.$services.notification
        .getReaded(this)
        .then(res => {
          this.$store.state.notification.readed.list = this.$store.state.notification.readed.list.concat(
            res.data.result.notifications
          );
        })
        .finally(() => {
          this.$store.state.notification.readed.isFetching = false;
        });
    }
  },
  created() {
    this.loadMoreReadedNotifications();
  }
};
</script>

<style scoped>
.notification-list {
  width: 400px;
  background-color: #000;
  margin-top: 4px;
  height: 400px;
  max-height: 90vh;
  max-width: 100%;
}
.header {
  padding: 4px 12px;
  background-color: #000;
  color: #eee;
  font-size: 12px;
  font-weight: bold;
}
.empty-hint {
  padding: 4px 12px;
  background-color: #111;
}
.btn-more {
  width: 100%;
}
</style>